/**
 * @param roiCalculatorDocument {Document}
 * @param onFormSubmitted {(data: RoiCalculatorFormData) => void}
 * @return {void}
 */
module.exports = function listenToRoiCalculatorFormSubmittedEvent(roiCalculatorDocument, onFormSubmitted) {
    roiCalculatorDocument.addEventListener("formSubmitted", (e) => {
        if ('calculatorData' in e.detail) {
            /**
             * @type {RoiCalculatorFormData}
             */
            const data = e.detail.calculatorData;

            onFormSubmitted(data);
        }
    });
}
